import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import styles from "./Ace.module.css";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-latex";
import "ace-builds/src-noconflict/theme-xcode";
import "ace-builds/src-noconflict/ext-language_tools";
import { HStack, IconButton, ButtonGroup, Tooltip, Modal, ModalBody, useDisclosure, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, Box, Button, Spinner } from "@chakra-ui/react";
import PopOver from "./Popover";
import {
  getAllBibitems,
  getAllEquations,
  getAllTables,
  showDeletedOnHover,
  querySelector,
  processSelection
} from "../Utils/utils";
import { getCitationMarkers, getInlineEqnMarkers, getEqnMarkers } from "../Utils/getMarkers";
import CitationPopup from "./CitationPopup";
import MathPopup from "./MathPopup";
// import { saveTexApi, downloadTexApi } from "../api";
import ImagePopup from "./ImagePopup";
import "ace-builds/src-noconflict/ext-searchbox";
import "ace-builds/src-noconflict/ext-spellcheck";
import { InsertMath } from "./InsertMath";
import { diff_match_patch } from "diff-match-patch";
import {
  SaveIcon,
  SearchIcon,
  ReplaceIcon,
  BoldIcon,
  ItalicIcon,
  Auto,
  Resize1,
  Resize2,
  MenuBar,
  MenuClose,
  HideChange,
  ShowChange,
} from "./icons";
import { connect } from "react-redux";
import epl from "../eplstyles";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "./Loading";
import { textToBold, textToItalics, toLowerCase, noBreak, hBox, customshortcuts } from "../Utils/shortcutBindings"
import { get_all_project_file_Api, update_project_file_Api } from "../dashboardapi";
// import { useMemo } from "react";
// import { debounce } from "lodash";

// import Tablepopup from "./Tablepopup";

const AceFunctional = forwardRef((props, ref) => {
  const {
    isOpen: alertOpen,
    onToggle: onalertToogle,
    onClose: onalertClose,
  } = useDisclosure();

  const dmp = new diff_match_patch();
  const toast = props.toast;
  const ace = useRef(null);
  // const editorValueRef = useRef('');
  // const popup = useRef();
  const [texFile, setTexFile] = useState("");
  // const [textFiletoCompare, settexFiletoCompare] = useState('')
  const [filename, setFilename] = useState("");
  const [markers, setMarkers] = useState([]);
  const [bibitems, setBibitems] = useState({});
  const [equations, setEquations] = useState({});
  const [tables, setTables] = useState({});
  const [actualValue, setActualValue] = useState("");
  const [lastSearch, setLastSearch] = useState("");
  const [toggleChange, setToggleChange] = useState(true);
  const [changes, setChanges] = useState([]);
  const [fileId, setFileID] = useState("");
  const [diffList, setDiffList] = useState([]);
  const [popUp, setPopUp] = useState({
    popup: { x: -100, y: -100, show: false, header: "", body: "", type: "" },
  });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  // console.log(props);
  const { projectid, file } = useParams();
  const [performancetime, setPerformanceTime] = useState("");
  const [alerttoshow, setAlertToShow] = useState(0)
  // let alert = 0;

  useEffect(() => {
    const projectfiles = async () => {
      const files = await get_all_project_file_Api(projectid);
      try {
        if (files.data) {
          // console.log(files.data);
          files.data.forEach((item, id) => {
            if (item.name === file) {
              setActualValue(item.proof_content ? item.proof_content : item.content)
              setTexFile(item.content)
              setFilename(item.name)
              setFileID(item.file_uuid)
              props.setFileName(item.project_name);
            }
          })
        } else {
          toast({
            title: "Error",
            description: "No such project found",
            status: "error",
            duration: 2000,
            isClosable: "true"
          })
          navigate("/dashboard/myprojects");
        }
      } catch (error) {
        setTexFile("No Files Found")
        setLoading(false)
      } finally {
        setLoading(false)
      }
      setTimeout(() => {
        enableMarkers();
        ace.current?.editor?.session.getUndoManager().reset();
      }, 2000);
    }
    projectfiles();

    ace.current.editor.setOption("enableMultiselect", false);
  }, [ace])

  // console.log(toggleChange);

  useEffect(() => {
    if (performancetime > 50 && alerttoshow < 1) {
      onalertToogle()
      setAlertToShow(1)
    }
  }, [performancetime])




  // Getting actual and correction file from api

  // useEffect(() => {
  //   const tex = async () => {
  //     const file = await downloadTexApi();
  //     try {
  //       setTexFile(file.data.tex);
  //       setActualValue(file.data.proof_tex);
  //       setFilename(file.data.file);
  //       props.setFileName(file.data.file);
  //     } catch (error) {
  //       setTexFile("No File Found");
  //       setLoading(false);
  //       // return navigate("home");
  //     } finally {
  //       setLoading(false);
  //     }

  //     setTimeout(() => {
  //       enableMarkers();
  //       ace.current.editor.session.getUndoManager().reset();
  //     }, 2000);
  //   };
  //   tex();

  //   ace.current.editor.setOption("enableMultiselect", false);
  //   // window.ace = ace.current;
  // }, []);

  useEffect(() => {
    onChange(texFile);
    props.uploadtex(texFile);
  }, [actualValue, texFile, onchange]);

  // useEffect(() => {
  //   props.uploadtex(texFile);
  // }, [changes, props, texFile]);

  useEffect(() => {
    if (!props.updateCorrections) {
      return;
    }
    var data = props.updateCorrections.payload
    var decision = props.updateCorrections.type
    console.log(decision)
    if (decision === "accept") {
      if (data.mode === "deleted") {
        let newAct = ""
        for (let i = 0; i < diffList.length; i++) {
          let curDiff = diffList[i]
          if (curDiff[0] === 0) {
            newAct = newAct + curDiff[1]
          } else if (curDiff[0] === -1 && i !== data.index) {
            newAct = newAct + curDiff[1]
          }
        }
        setActualValue(newAct)
      } else if (data.mode === "added") {
        let newAct = ""
        for (let i = 0; i < diffList.length; i++) {
          let curDiff = diffList[i]
          if (curDiff[0] === 0 || curDiff[0] === -1) {
            newAct = newAct + curDiff[1]
          } else if (curDiff[0] === 1 && i === data.index) {
            newAct = newAct + curDiff[1]
          }
        }
        setActualValue(newAct)
      }
    } else if (decision === "reject") {
      if (data.mode === "deleted") {
        let newAct = ""
        for (let i = 0; i < diffList.length; i++) {
          let curDiff = diffList[i]
          if (curDiff[0] === 0 || curDiff[0] === 1) {
            newAct = newAct + curDiff[1]
          } else if (curDiff[0] === -1 && i === data.index) {
            newAct = newAct + curDiff[1]
          }
        }
        setTexFile(newAct)
      } else if (data.mode === "added") {
        console.log("SASSA")
        let newAct = ""
        for (let i = 0; i < diffList.length; i++) {
          let curDiff = diffList[i]
          if (curDiff[0] === 0) {
            newAct = newAct + curDiff[1]
          } else if (curDiff[0] === 1 && i !== data.index) {
            newAct = newAct + curDiff[1]
          }
        }
        setTexFile(newAct)
      }
    }
  }, [diffList, props.updateCorrections]);

  // sending ref from child to parent component

  useImperativeHandle(ref, () => ({
    editor: ace?.current?.editor,
  }));

  // useeffect to scrolltoline in PE/CE Tools;

  useEffect(() => {
    if (props.selection) {
      let start = props.selection.start;
      ace.current.editor.session.selection.setSelectionRange(props.selection);
      ace.current.editor.scrollToLine(start.row);
    }
  }, [props.selection]);

  // useeffect for showing deleted text on hover

  useEffect(() => {
    let editor = ace.current;
    if (changes) {
      editor?.editor?.on("mousemove", (e) => showDeletedOnHover(e, changes, setPopUp, popUp, hidePopover));
    }
    return () => {
      if (editor) {
        editor?.editor?.off("mousemove", showDeletedOnHover);
      }
    };
  }, [changes, popUp]);

  // useeffect for showing the markers on selection
  useEffect(() => {
    let editor = ace.current;
    if (markers) {
      editor?.editor?.on("mouseup", (e) => processSelection(e, hidePopover, markers, bibitems, setPopUp, ImagePopup, CitationPopup, toast, MathPopup, equations, props, tables));
    }
    return () => {
      if (editor) {
        editor?.editor?.off("mouseup", processSelection);
      }
    };
  }, [markers]);

  useEffect(() => {
    document.addEventListener("keydown", function (event) {
      if (event.ctrlKey && event.key === "T") {
        event.preventDefault();
      }
    });
  }, []);

  // useeffect for shortcut key bindings
  useEffect(() => {
    ace.current.editor.commands.addCommand({
      name: "TextBold",
      bindKey: {
        win: "Ctrl-B",
        mac: "Command-B",
      },
      exec: () => textToBold(ace),
      readOnly: true,
    });
    ace.current.editor.commands.addCommand({
      name: "TextItalic",
      bindKey: {
        win: "Ctrl-I",
        mac: "Command-I",
      },
      exec: () => textToItalics(ace),
      readOnly: true,
    });
    ace.current.editor.commands.addCommand({
      name: "lowercase",
      bindKey: {
        win: "Alt-L",
        mac: "Alt-L",
      },
      exec: () => toLowerCase(ace),
      readOnly: true,
    });
    ace.current.editor.commands.addCommand({
      name: "nobreak",
      bindKey: {
        win: "Alt-B",
        mac: "Command-Option-B",
      },
      exec: () => noBreak(ace),
      readOnly: true,
    });
    ace.current.editor.commands.addCommand({
      name: "hBox",
      bindKey: {
        win: "Ctrl-Shift-H",
        mac: "Command-Shift-H",
      },
      exec: () => hBox(ace),
      readOnly: true,
    });
    ace.current.editor.commands.addCommand({
      name: "Latex Compile",
      bindKey: {
        win: "Ctrl-L",
        mac: "Command-L",
      },
      exec: props.compileTex,
      readOnly: true,
    });
    ace.current.editor.commands.addCommand({
      name: "Track Latex Compile",
      bindKey: {
        win: "Ctrl-K",
        mac: "Command-K",
      },
      exec: props.compileTrack,
      readOnly: true,
    });
    // const test = (a, b) => {
    //   console.log(a, b);
    // };
    // ace.current.editor.commands.addCommand({
    //   name: "shortcuts",
    //   bindKey: {
    //     win: "Ctrl-1|Ctrl-2",
    //   },
    //   exec: test,
    //   readOnly: true,
    // });

    ace.current.editor.commands.addCommand({
      name: "looseness-1",
      bindKey: {
        win: "Ctrl-1",
        mac: "Ctrl-1",
      },
      exec: () => customshortcuts(1, ace),
      readOnly: true,
    });
    ace.current.editor.commands.addCommand({
      name: "vfill\\eject",
      bindKey: {
        win: "Ctrl-2",
        mac: "Ctrl-2",
      },
      exec: () => customshortcuts(2, ace),
      readOnly: true,
    });
    ace.current.editor.commands.addCommand({
      name: "unskip\\break",
      bindKey: {
        win: "Ctrl-3",
        mac: "Ctrl-3",
      },
      exec: () => customshortcuts(3, ace),
      readOnly: true,
    });
    ace.current.editor.commands.addCommand({
      name: "custom_shortcut_1",
      bindKey: {
        win: "Ctrl-4",
        mac: "Ctrl-4",
      },
      exec: () => customshortcuts(4, ace),
      readOnly: true,
    });
    ace.current.editor.commands.addCommand({
      name: "custom_shortcuts_2",
      bindKey: {
        win: "Ctrl-5",
        mac: "Ctrl-5",
      },
      exec: () => customshortcuts(5, ace),
      readOnly: true,
    });
    ace.current.editor.commands.addCommand({
      name: "custom_shortcuts_3",
      bindKey: {
        win: "Ctrl-6",
        mac: "Ctrl-6",
      },
      exec: () => customshortcuts(6, ace),
      readOnly: true,
    });
  });

  // useeffect for searching the text in pdf on selection in editor
  useEffect(() => {
    let curSearch = props.latexsearch;
    if (curSearch && curSearch.length > 3 && curSearch !== lastSearch) {
      setSearchFromPdf(curSearch);
      setLastSearch(curSearch);
    }
  }, [props.latexsearch, lastSearch]);

  // function to search the text on editor on selection in pdf
  const setSearchFromPdf = (search) => {
    ace.current.editor.find(search);
  };


  // function to hidepopups

  const hidePopover = () => {
    setPopUp({ popup: { show: false } });
  };

  // function to enable markers in ace editor
  const enableMarkers = () => {
    if (texFile) {
      setBibitems(getAllBibitems(texFile));
      setEquations(getAllEquations(texFile));
      setTables(getAllTables(texFile));
    }
    // getAllBibitems(texFile);
    if (ace?.current?.editor) {
      var citationMarkers = getCitationMarkers("", styles, ace);
      var imageMarkers = getCitationMarkers("image", styles, ace);
      var tableMarkers = getCitationMarkers("Table", styles, ace);
      var equationMarkers = getCitationMarkers("equation", styles, ace);
      var inlineEqnMarkers = getInlineEqnMarkers(ace, styles);
      var eqnMarkers = getEqnMarkers(ace, styles);
      var allMarkers = [].concat(
        citationMarkers,
        inlineEqnMarkers,
        eqnMarkers,
        imageMarkers,
        tableMarkers,
        equationMarkers
      );
    }
    setMarkers(allMarkers);
    querySelector(ace, props);
  };

  // const Diffcalc = useMemo(() => {
  //   // Memoized diff calculation
  //   return (actualValue, newValue) => {
  //     const diff = dmp.diff_main(actualValue, newValue);
  //     // dmp.diff_cleanupSemantic(diff); // Optional: improve diff quality
  //     return diff;
  //   };
  // }, []);

  // const debouncedOnChange = useCallback(
  //   debounce((actualValue, newValue) => {
  //     const diff = Diffcalc(actualValue, newValue);
  //     console.log(diff); // Handle the diff
  //   }, 100), // Adjust the delay as needed
  //   []
  // // );

  // const processDiffAndMarkers = useCallback(
  //   debounce((actualValue, newValue) => {
  //     const diff = Diffcalc(actualValue, newValue);
  //     let allMarkers = [];
  //     let st = 0;
  //     setDiffList(diff);

  //     // Generate markers from diff
  //     for (let j = 0; j < diff.length; j++) {
  //       const i = diff[j];
  //       console.log(i);

  //       if (i[0] === 1) {
  //         let value = i[1];
  //         let start = ace.current.editor.session.doc.indexToPosition(st);
  //         let end = ace.current.editor.session.doc.indexToPosition(
  //           st + value.length
  //         );
  //         allMarkers.push({
  //           startRow: start.row,
  //           startCol: start.column,
  //           endRow: end.row,
  //           endCol: end.column,
  //           startIndex: st,
  //           endIndex: end,
  //           className: styles.added_marker,
  //           type: "text",
  //           text: value,
  //           mode: "added",
  //           index: j
  //         });
  //         st += value.length;
  //       } else if (i[0] === -1) {
  //         let value = i[1];
  //         let start = ace.current.editor.session.doc.indexToPosition(st);
  //         let end = ace.current.editor.session.doc.indexToPosition(st);
  //         allMarkers.push({
  //           // time: time,
  //           startRow: start.row,
  //           startCol: start.column,
  //           endRow: end.row,
  //           endColumn: end.column,
  //           startIndex: st,
  //           endIndex: end,
  //           className: styles.deleted_marker,
  //           type: "background",
  //           text: value,
  //           mode: "deleted",
  //           index: j
  //         });
  //       } else {
  //         st = st + i[1].length;
  //       }

  //     }

  //     // Update markers and call actions
  //     setChanges(allMarkers);
  //     props.exampleAction(allMarkers);
  //     enableMarkers();
  //     return true
  //   }, 700), // Adjust debounce delay for better performance
  //   []
  // );

  // const onChange = (newValue) => {
  //   setTexFile(newValue);
  //   editorValueRef.current = newValue;

  //   // Debounced diff calculation
  //   processDiffAndMarkers(actualValue, newValue);
  // };

  // console.log("time taken :", performancetime);


  // function to compare changes in the tex file and actual file.
  const onChange = (newValue) => {
    if (toggleChange && newValue) {
      let start = performance.now()
      var r = dmp.diff_main(actualValue, newValue);
      // var r = debouncedOnChange(actualValue, newValue)
      // dmp.diff_cleanupSemantic(r)
      // var p = dmp.patch_make(r)
      // console.log(r);
      // console.log(p);
      let allMarkers = [];
      var st = 0;
      setDiffList(r);
      for (var j = 0; j < r.length; j++) {
        var i = r[j]
        if (i[0] === 1) {
          let value = i[1];
          let start = ace.current.editor.session.doc.indexToPosition(st);
          let end = ace.current.editor.session.doc.indexToPosition(
            st + value.length
          );
          allMarkers.push({
            // time: time,
            startRow: start.row,
            startCol: start.column,
            endRow: end.row,
            endCol: end.column,
            startIndex: st,
            endIndex: end,
            className: styles.added_marker,
            type: "text",
            text: value,
            mode: "added",
            index: j
          });
          st = st + value.length;
        } else if (i[0] === -1) {
          let value = i[1];
          let start = ace.current.editor.session.doc.indexToPosition(st);
          let end = ace.current.editor.session.doc.indexToPosition(st);
          allMarkers.push({
            // time: time,
            startRow: start.row,
            startCol: start.column,
            endRow: end.row,
            endColumn: end.column,
            startIndex: st,
            endIndex: end,
            className: styles.deleted_marker,
            type: "background",
            text: value,
            mode: "deleted",
            index: j
          });
        } else {
          st = st + i[1].length;
        }
      }
      let end = performance.now();
      setChanges(allMarkers);
      props.exampleAction(allMarkers);
      setPerformanceTime(end - start)
    }

    setTexFile(newValue);
    enableMarkers();
    return true;
  };

  // // function to insert Math equations in texfile
  const insertMath = (text) => {
    ace.current.editor.session.insert(
      ace.current.editor.getCursorPosition(),
      text
    );
  };

  // console.log(changes)

  // function to save texfile
  const saveTex = async () => {
    props.toast({
      title: "Saving Tex.",
      description: "File is being saved, Please wait.",
      status: "info",
      icon: (
        <Spinner
          thickness="4px"
          emptyColor="gray.200"
          color="blue.500"
          size="sm"
        />
      ),
    });
    // var result = await saveTexApi(texFile, changes);
    var result = await update_project_file_Api(projectid, fileId, filename, texFile)
    if (result.data) {
      props.toast.closeAll();
      console.log(result.data);

      props.toast({
        title: "Tex saved.",
        description: "Save successfull.",
        status: "success",
        duration: 1000,
      });
    }
  };



  const AutoCorrect = () => {
    toast({ title: "Feature yet to be Implemented" });
  };

  // useeffect to apply copy editing styles.

  useEffect(() => {
    if (!props.editing) {
      // toast({ title: "Error in applying styles" });
      return;
    }
    var currentstyle;
    var tempFile = texFile;
    if (tempFile !== "No File Found") {
      props.editing.forEach((i) => {
        currentstyle = epl[i].name;
        tempFile = epl[i].action(tempFile, filename, toast);
      });
      toast({
        title: "Applying Styles",
        description: currentstyle,
        duration: 1500,
      });
      setTexFile(tempFile);
    } else {
      toast({
        title: "Error",
        description: "Please Load file to continue.",
        duration: 1500,
      });
    }
  }, [props.editing]);

  return (
    <>
      <div style={styles.ace_editor}>
        <Loading loading={loading} />
        <span>
          <HStack
            backgroundColor="#F26722"
            justifyContent="space-between"
            maxH="48px"
            minH="48px"
          >
            <ButtonGroup spacing="1">
              {props.leftController ? (
                <Tooltip label="Close panel">
                  <IconButton
                    onClick={() => {
                      props.toggleLeftPanel();
                    }}
                    size="lg"
                    colorScheme="#F26722"
                    aria-label="Close Left Panel"
                    icon={<MenuClose />}
                    _hover={{ bg: "#E05E1D" }}
                  />
                </Tooltip>
              ) : (
                <Tooltip label="Open panel">
                  <IconButton
                    onClick={() => {
                      props.toggleLeftPanel();
                    }}
                    size="lg"
                    colorScheme="#F26722"
                    aria-label="Open Left Panel"
                    icon={<MenuBar />}
                    _hover={{ bg: "#E05E1D" }}
                  />
                </Tooltip>
              )}
              <Tooltip label="Save">
                <IconButton
                  onClick={saveTex}
                  size="lg"
                  colorScheme="#f47c0d"
                  aria-label="Save Tex File"
                  icon={<SaveIcon />}
                  _hover={{ bg: "#E05E1D" }}
                />
              </Tooltip>
              <Tooltip label="Search">
                <IconButton
                  onClick={() => ace.current.editor.execCommand("find")}
                  size="lg"
                  colorScheme="#f47c0d"
                  aria-label="Search inside document"
                  icon={<SearchIcon />}
                  _hover={{ bg: "#E05E1D" }}
                />
              </Tooltip>
              <Tooltip label="Replace">
                <IconButton
                  onClick={() => ace.current.editor.execCommand("replace")}
                  color="white"
                  size="lg"
                  colorScheme="#f47c0d"
                  aria-label="Replace inside document"
                  icon={<ReplaceIcon />}
                  _hover={{ bg: "#E05E1D" }}
                />
              </Tooltip>

              <InsertMath insertMath={insertMath} />

              <Tooltip label="Text to Bold">
                <IconButton
                  onClick={() => textToBold(ace)}
                  size="lg"
                  colorScheme="#f47c0d"
                  aria-label="Text to Bold"
                  icon={<BoldIcon />}
                  _hover={{ bg: "#E05E1D" }}
                />
              </Tooltip>
              <Tooltip label="Text to Italic">
                <IconButton
                  onClick={() => textToItalics(ace)}
                  fontSize="l"
                  size="lg"
                  colorScheme="#f47c0d"
                  aria-label="Text to Italic"
                  icon={<ItalicIcon />}
                  _hover={{ bg: "#E05E1D" }}
                />
              </Tooltip>
              <Tooltip label="SpellCheck">
                <IconButton
                  onClick={AutoCorrect}
                  size="lg"
                  colorScheme="#f47c0d"
                  aria-label="Autocorrect"
                  icon={<Auto />}
                  _hover={{ bg: "#E05E1D" }}
                />
              </Tooltip>
              <Tooltip label="Show/Hide Changes">
                <IconButton
                  onClick={() => { setToggleChange(!toggleChange); onChange(texFile) }}
                  size="lg"
                  colorScheme="#f47c0d"
                  aria-label="Show/Hide Changes"
                  icon={toggleChange ? <ShowChange /> : <HideChange />}
                  _hover={{ bg: "#E05E1D" }}
                />
              </Tooltip>
            </ButtonGroup>
            {props.pdfviewer ? (
              <Tooltip label="Expand Editor">
                <IconButton
                  onClick={() => {
                    props.togglePDF();
                  }}
                  size="lg"
                  colorScheme="#f47c0d"
                  aria-label="toogle-pdf"
                  position="absolute"
                  right="0"
                  z-index="2"
                  bg="#F26722"
                  icon={<Resize1 />}
                  _hover={{ bg: "#E05E1D" }}
                ></IconButton>
              </Tooltip>
            ) : (
              <Tooltip label="Minimise editor">
                <IconButton
                  onClick={() => {
                    props.togglePDF();
                  }}
                  size="lg"
                  position="absolute"
                  right="0"
                  colorScheme="#f47c0d"
                  aria-label="toogle-pdf"
                  icon={<Resize2 />}
                  _hover={{ bg: "#E05E1D" }}
                ></IconButton>
              </Tooltip>
            )}
          </HStack>

          <PopOver state={popUp} onClick={() => hidePopover()} />
          <Modal isOpen={alertOpen} onClose={onalertClose} isCentered>
            <ModalOverlay>
              <ModalContent>
                <ModalHeader>
                  Alert
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody overflow="auto" padding="20px">
                  <Box>
                    <p>
                      Corrections on the file is too high please disable the Real Time Diff functionality to have a smooth editing experience.
                    </p>
                  </Box>
                  <Box mt="15px">
                    <Button onClick={() => { setToggleChange(false); onalertClose() }}> Turn off Real Time Diff </Button>
                  </Box>
                </ModalBody>
              </ModalContent>
            </ModalOverlay>
          </Modal>

          <AceEditor
            // onMouseMove={showDeletedOnHover}
            ref={ace}
            markers={toggleChange ? markers.concat(changes) : markers}
            mode="latex"
            theme="xcode"
            name="ace_editor"
            wrapEnabled={true}
            editorProps={{ $blockScrolling: true }}
            options={{ enableMultiselect: false }}
            fontSize={18}
            onChange={onChange}
            value={texFile}
            enableSnippets={true}
            enableBasicAutocompletion={true}
            enableLiveAutocompletion={true}
            width="100%"
            height="calc(90vh - 48px)"
          />
        </span>
      </div>
    </>
  );
});

//Dispatch state to props redux
const mapStateToProps = (state, ownProps) => ({
  data: state.correction.corrections,
  latexsearch: state.latexsearch.latexSearch,
  selection: state.toolsearch.toolSearch,
  query: state.queries.queries,
  editing: state.eplStyles.function,
  compileTex: state.compileTex.compile,
  compileTrack: state.trackCompile.trackcompile,
  updateCorrections: state.updateCorrections.corrections,
});

//Dispatch action redux
const mapDispatchToProps = (dispatch) => {
  return {
    exampleAction: (data) => dispatch({ type: "EDIT", payload: data }),
    querydata: (data) => dispatch({ type: "QueryEdit", payload: data }),
    uploadtex: (data) => dispatch({ type: "UploadTex", payload: data }),
    pdfsearch: (data) => dispatch({ type: "pdfSearch", payload: data }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(AceFunctional);
